let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gBLO")).then(() => parcelRequire('IcBtj'));